const VARIANT_SWATCHES = {
  "Rose Quartz": { "hex": "#F7CAC9" },
  "Yankey Blue": { "hex": "#1C2841" },
  "Fan Marine Green": { "hex": "#2F5D50" },
  "Asphalt": { hex: "#6c6864" },
  "Athletic Heather": { hex: "#d5d5d5" },
  "Black": { hex: "#000000" },
  "Dark Grey Heather": { hex: "#5f6366" },
  "Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal_Heather.jpg?v=1752688403' },
  "Light Grey": { hex: "#D3D3D3" },
  'White/ Denim': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Denim2.jpg?v=1749844663' },
  "Antique Denim": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Antique-Denim.jpg?v=1751310039' },
  "Black/ Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Grey.jpg?v=1752261131' },
  "Alpine Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Alpine_Green.jpg?v=1752688403' },
  "Charcoal Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal_Heather.jpg?v=1752688403' },
  "Grey Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey_Heather.jpg?v=1752688403' },
  "Desert Rose": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Desert_Rose.jpg?v=1752682762' },
  "Digital Red Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Digital_Red_Camo.jpg?v=1752696476' },
  "Golden Yellow": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Golden_Yellow.jpg?v=1752696475' },
  "Retro Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Retro_Camo.jpg?v=1752696475' },
   "Black Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Camo_90559704-8909-4b09-aeda-ec6a0f15deeb.jpg?v=1752688549' },
   "Classic Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Classic_Navy.jpg?v=1752688549' },
   "Duck Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Duck_Camo.jpg?v=1752688549' },
  "Bright Yellow": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Bright_Yellow.jpg?v=1752696252' },
  "Florida Teal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Florida_Teal.jpg?v=1752696252' },
   "Forest Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Forest_Camo.jpg?v=1752688549' },
  "Deep Forest": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Deep_Forest.jpg?v=1752695792' },
  "Deep Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Deep_Red.jpg?v=1752695792' },
  "Light Steel": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Light_Steel.jpg?v=1752695867' },
  "Pale Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pale_Pink.jpg?v=1752695868' },
  "Smoke Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Smoke_Grey.jpg?v=1752695868' },
  "Eternity": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Eternity.jpg?v=1752682763' },
  "Flashback": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Flashback.jpg?v=1752682762' },
  "Lagoon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lagoon.jpg?v=1752682762' },
  "Multi Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multi_Black.jpg?v=1752682763' },
  "Multi Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multi_Blue.jpg?v=1752682762' },
  "Neon Rainbow": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Neon_Rainbow.jpg?v=1752682762' },
  "Prism": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Prism.jpg?v=1752682762' },
  "Greystone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Greystone.jpg?v=1752681732' },
  "Heather Steel": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Steel.jpg?v=1752681733' },
  "Pacific Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pacific_Blue.jpg?v=1752681733' },
  "Heather Granite": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Granite.jpg?v=1752682521' },
  "Bright Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Bright_Pink.jpg?v=1752682570' },
  "Camo/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Camo_Black.jpg?v=1752264339' },
  "Brown/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brown_White.jpg?v=1752339707' },
  "Brown/ White/ Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brown_White_Brown.jpg?v=1752339707' },
  "Carolina Blue/ White/ Caroline Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Carolina_Blue_White_Caroline_Blue.jpg?v=1752339707' },
  "Kelly/ White/ Kelly": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Kelly_White_Kelly.jpg?v=1752339707' },
  "Pink/ White/ Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pink_White_Pink.jpg?v=1752339707' },
  "Red/ White/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red_White_Red.jpg?v=1752339707' },
  "Royal/ White/ Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal_White_Royal.jpg?v=1752339707' },
  "Silver/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Silver_Black.jpg?v=1752339707' },
   "Black/ White/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_White_Black.jpg?v=1752338673' },
   "Coyote Brown/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Coyote_Brown_Black.jpg?v=1752338673' },
   "Evergreen": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Evergreen.jpg?v=1752338673' },
   "Evergreen/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Evergreen_White.jpg?v=1752338673' },
   "Kryptek Highlander": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Kryptek_Highlander.jpg?v=1752338673' },
   "Kryptek Pontus": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Kryptek_Pontus.jpg?v=1752338673' },
   "Kryptek Raid": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Kryptek_Raid.jpg?v=1752338673' },
   "Kryptek Typhon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Kryptek_Typhon.jpg?v=1752338673' },
   "Kryptek Wraith": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Kryptek_Wraith.jpg?v=1752338673' },
   "Maroon/ Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Maroon_Grey.jpg?v=1752338673' },
   "Moss/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Moss_Khaki.jpg?v=1752338673' },
   "Multicam Alpine/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multicam_Alpine_White.jpg?v=1752338673' },
   "Multicam Arid/ Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multicam_Arid_Brown.jpg?v=1752338673' },
   "Multicam Arid/ Tan": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multicam_Arid_Tan.jpg?v=1752338673' },
   "Multicam Black/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multicam_Black_Black.jpg?v=1752338673' },
   "Multicam Green/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multicam_Green_Black.jpg?v=1752338673' },
   "Multicam Green/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multicam_Green_Khaki.jpg?v=1752338673' },
   "Multicam Tropic/ Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multicam_Tropic_Green.jpg?v=1752338673' },
   "Navy/ Silver": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy_Silver.jpg?v=1752338673' },
   "Navy/ White/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy_White_Navy.jpg?v=1752338673' },
   "Poseidon Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Poseidon_Black.jpg?v=1752338673' },
   "Realtree Max7/ Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Realtree_Max7_Brown.jpg?v=1752338673' },
   "Rustic Orange/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Rustic_Orange_Khaki.jpg?v=1752338673' },
   "Steel Blue/ Silver": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Steel_Blue_Silver.jpg?v=1752338673' },
   "Turquoise/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Turquoise_White.jpg?v=1752338673' },
   "Veil Wideland": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Veil_Wideland.jpg?v=1752338673' },
   "Black/ Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Camo.jpg?v=1752337836' },
   "Black/ Neon Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Neon_Green.jpg?v=1752337836' },
   "Black/ Neon Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Neon_Orange.jpg?v=1752337836' },
   "Black/ Purple": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Purple.jpg?v=1752337836' },
   "Black/ Silver": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Silver.jpg?v=1752337836' },
   "Black/ Teal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Teal.jpg?v=1752337836' },
   "Dark Heather/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Heather_Black.jpg?v=1752337837' },
   "Dark Heather/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Heather_Red.jpg?v=1752337836' },
   "Multicam Alpine": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multicam_Alpine.jpg?v=1752337836' },
   "Multicam Arid": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multicam_Arid.jpg?v=1752337836' },
   "Multicam Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multicam_Black.jpg?v=1752337836' },
   "Multicam Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multicam_Green.jpg?v=1752337836' },
   "Multicam Tropic": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multicam_Tropic.jpg?v=1752337836' },
  "Heather/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Black.jpg?v=1752337318' },
  "Heather/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_White.jpg?v=1752337318' },
  "Moss Green/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Moss_Green_Khaki.jpg?v=1752273702' },
  "Neon Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Neon_Orange.jpg?v=1752264339' },
  "Diamond Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Diamond_Blue.jpg?v=1752336922' },
   "Baby Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Baby_Pink.jpg?v=1752273233' },
   "Spruce": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spruce.jpg?v=1752273233' },
   "Black/ Stone Stitch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Stone_Stitch.jpg?v=1752264798' },
  "Periwinkle": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Periwinkle.jpg?v=1752267182' },
   "Brown/ Stone Stitch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brown_Stone_Stitch.jpg?v=1752264798' },
   "Grey/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey_Navy.jpg?v=1752264798' },
   "Red/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red_Red.jpg?v=1752265442' },
   "Royal/ Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal_Royal.jpg?v=1752265442' },
   "Khaki/ Forest Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Khaki_Forest_Green.jpg?v=1752266039' },
   "Khaki/ Maroon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Khaki_Maroon.jpg?v=1752266039' },
   "Khaki/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Khaki_Navy.jpg?v=1752266039' },
   "Natural/ Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural_Brown.jpg?v=1752266039' },
   "Natural/ Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural_Charcoal.jpg?v=1752266039' },
   "Natural/ Forest Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural_Forest_Green.jpg?v=1752266170' },
   "Natural/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural_Khaki.jpg?v=1752266039' },
  "White/ Forest": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White_Forest.jpg?v=1752266039' },
   "Khaki/ Brown Stitch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Khaki_Brown_Stitch.jpg?v=1752264798' },
   "Navy/ Stone Stitch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy_Stone_Stitch.jpg?v=1752264798' },
   "Olive/ Stone Stitch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Olive_Stone_Stitch.jpg?v=1752264798' },
   "Pink Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pink_Camo.jpg?v=1752264798' },
   "Sky Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sky_Blue_37f17bf2-cf91-4595-81d1-d121db4e6aa0.jpg?v=1752264798' },
   "Tan Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tan_Camo.jpg?v=1752264798' },
   "Green Camo/ Tan": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Green_Camo_Tan.jpg?v=1752264181' },
   "White/ Royal/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White_Royal_Red.jpg?v=1752264181' },
   "White/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White_White.jpg?v=1752264181' },
   "Black/ Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Orange.jpg?v=1752261370' },
   "Dark Green/ Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Green_Gold.jpg?v=1752261370' },
  "Golden Brown/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Golden_Brown-Khaki.jpg?v=1752261131' },
  "Olive Green/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Olive_Green-Navy.jpg?v=1752261131' },
  "Forest": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Forest_c9c9c0af-697b-4272-9d5e-b745e5d93b3e.jpg?v=1752261253' },
  "Army Olive Green/ Tan": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Army_Olive_Green_Tan.jpg?v=1751742469' },
  "Beetle/ Quarry": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Beetle_Quarry.jpg?v=1751742469' },
  "Blue Teal/ Birch/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Blue_Teal_Birch_Navy.jpg?v=1751742469' },
  "Chocolate Chip/ Birch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chocolate_Chip_Birch.jpg?v=1751742469' },
  "Cobalt Blue/ Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cobalt_Blue_Grey.jpg?v=1751742469' },
  "Heather Grey/ Amber Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey_Amber_Gold.jpg?v=1751742469' },
  "Heather Grey/ Birch/ Army Olive": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey_Birch_Army_Olive.jpg?v=1751742469' },
  "Heather Grey/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey_Black.jpg?v=1751742469' },
  "Khaki/ Coffee": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Khaki_Coffee.jpg?v=1751742469' },
  "Loden Green/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Loden_Green_Black.jpg?v=1751742469' },
  "Ombre Blue/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ombre_Blue_Navy.jpg?v=1751742469' },
  "Pale Khaki/ Loden Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pale_Khaki_Loden_Green.jpg?v=1751742469' },
  "Birch/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Birch-Black.jpg?v=1751741861' },
  "Biscuit/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Biscuit-_Black.jpg?v=1751741861' },
  "Cardinal/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cardinal-_White.jpg?v=1751741861' },
  "Charcoal/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-White.jpg?v=1751741861' },
  "Dark Orange/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Orange-Black.jpg?v=1751741861' },
  "Loden/ Amber Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Loden-Amber_Gold.jpg?v=1751741861' },
  "Pale Peach/ Maroon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pale_Peach-_Maroon.jpg?v=1751741861' },
  "Red/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red-_White.jpg?v=1751741861' },
  "Black/ Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-_Gold.jpg?v=1751647916' },
  "Dark Heather Grey/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Heather_Grey-_Black.jpg?v=1751647916' },
  "Dark Heather Grey/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Heather_Grey-Navy.jpg?v=1751647916' },
  "Dark Heather Grey/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Heather_Grey-_Red.jpg?v=1751647916' },
  "Forest/ Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Forest-_Gold.jpg?v=1751647915' },
  "Light Heather Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Light_Heather_Grey.jpg?v=1751647915' },
  "Navy/ Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-_Gold.jpg?v=1751647916' },
  "Red/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red-_Black.jpg?v=1751647916' },
  "Red/ Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red-Gold.jpg?v=1751647915' },
  "Royal/ Light Heather Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal-_Light_Heather_Grey.jpg?v=1751647915' },
  "Royal/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal-Red.jpg?v=1751647916' },
  "Black/ Heather Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Heather-Grey.jpg?v=1751317333' },
  "Black Heather/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Heather_White.jpg?v=1751485397' },
  "Grey Heather/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey_HeatherBlack.jpg?v=1751485397' },
  "Grey Heather/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey_Heather_Black.jpg?v=1751485397' },
  "Ice Blue Heather/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ice_Blue_Heather_Navy.jpg?v=1751485397' },
  "Khaki Heather/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Khaki_Heather_Khaki.jpg?v=1751485397' },
  "X Hatch Black/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/X_Hatch_Black_Black.jpg?v=1751485397' },
  "X Hatch Grey/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/X_Hatch_Grey_White.jpg?v=1751485397' },
  "X Hatch Khaki/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/X_Hatch_Khaki_Black.jpg?v=1751485397' },
  "X Hatch Red/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/X_Hatch_Red_Khaki.jpg?v=1751485397' },
  "Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather.jpg?v=1751399473' },
  "Camel": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Camel.jpg?v=1751485892' },
   "Brushed Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brushed_Black.jpg?v=1751648714' },
   "Brushed Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brushed_Charcoal.jpg?v=1751648714' },
   "Brushed Dark Olive Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brushed_Dark_Olive_Green.jpg?v=1751648714' },
   "Brushed Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brushed_Navy.jpg?v=1751648714' },
   "Chino Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Black.jpg?v=1751648714' },
   "Chino Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Blue.jpg?v=1751648714' },
   "Chino Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Charcoal.jpg?v=1751648714' },
   "Chino Dark Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Dark_Brown.jpg?v=1751648714' },
   "Chino Dark Olive Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Dark_Olive_Green.jpg?v=1751648714' },
   "Chino Forest Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Forest_Green.jpg?v=1751648714' },
   "Chino Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Grey.jpg?v=1751648714' },
   "Chino Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Khaki.jpg?v=1751648714' },
   "Chino Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Navy.jpg?v=1751648714' },
   "Chino Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Red.jpg?v=1751648714' },
   "Chino Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Royal.jpg?v=1751648714' },
   "Chino Stone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Stone.jpg?v=1751648714' },
   "Chino Texas Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Texas_Orange.jpg?v=1751648714' },
   "Chino White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_White.jpg?v=1751648714' },
   "Old Wash Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Old_Wash_Black.jpg?v=1751648714' },
   "Old Wash Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Old_Wash_Blue.jpg?v=1751648714' },
   "Old Wash Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Old_Wash_Grey.jpg?v=1751648714' },
   "Pigment Aqua": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pigment_Aqua.jpg?v=1751648714' },
   "Pigment Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pigment_Black.jpg?v=1751648714' },
   "Pigment Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pigment_Brown.jpg?v=1751648714' },
   "Pigment Mustard Yellow": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pigment_Mustard_Yellow.jpg?v=1751648714' },
   "Pigment Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pigment_Navy.jpg?v=1751648714' }, 
   "Pigment Olive Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pigment_Olive_Green.jpg?v=1751648714' }, 
   "Pigment Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pigment_Red.jpg?v=1751648714' },
   "Pigment Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pigment_Royal.jpg?v=1751648714' },
  "Pigment Stone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pigment_Stone.jpg?v=1751648714' },
  "Pigment Tan": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pigment_Tan.jpg?v=1751648714' },
  "Pigment Teal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pigment_Teal.jpg?v=1751648714' },
  "Pigment Texas Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pigment_Texas_Orange.jpg?v=1751648714' },
  "Vintage Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage_Gold.jpg?v=1751648714' },
   "Black Camo/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Camo-Black.jpg?v=1751643789' },
   "Chino Black Duck Camo/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Black_Duck_Camo-_Black.jpg?v=1751643789' },
   "Chino Black/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Black-White.jpg?v=1751643789' },
   "Chino Cardinal/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Cardinal-_White.jpg?v=1751643789' },
   "Chino Charcoal/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Charcoal-_Black.jpg?v=1751643789' },
   "Chino Duck Camo/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Duck_Camo-White.jpg?v=1751643789' },
   "Chino Forest Green/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Forest_Green-_White.jpg?v=1751643789' },
   "Chino Grey/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Grey-_Black.jpg?v=1751643789' },
   "Chino Khaki/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Khaki-_Black.jpg?v=1751643789' },
   "Chino Maroon/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Maroon-Black.jpg?v=1751643790' },
   "Chino Navy/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Navy-_White.jpg?v=1751643789' },
   "Chino Orange/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Orange-_White.jpg?v=1751643789' },
   "Chino Red/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Red-White.jpg?v=1751643789' },
   "Chino Royal/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Royal-White.jpg?v=1751643789' },
   "Chino Sky Blue/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Sky_Blue-_White.jpg?v=1751643789' },
   "Chino Stone/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Stone-_Navy.jpg?v=1751643789' },
   "Chino Vegas Gold/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_Vegas_Gold-Black.jpg?v=1751643789' },
   "Chino White/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chino_White-_Navy.jpg?v=1751643789' },
   "Grey Camo/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey_Camo-Black.jpg?v=1751643789' },
   "Heather Grey/ Charcoal/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_Charcoal-Black.jpg?v=1751643789' },
   "Heather Grey/ Charcoal/ Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_Charcoal-_Charcoal.jpg?v=1751643789' },
   "Heather Grey/ Charcoal/ Forest Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Camel.jpg?v=1751485892' },
   "Heather Grey/ Charcoal/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-Charcoal-Navy.jpg?v=1751643789' },
   "Heather Grey/ Charcoal/ Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_Charcoal-_Orange.jpg?v=1751643789' },
   "Heather Grey/ Charcoal/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_Charcoal-_Red.jpg?v=1751643789' },
   "Heather Grey/ Charcoal/ Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_Charcoal-_Royal.jpg?v=1751643789' },
   "Heather Grey/ Charcoal/ Vegas Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_Charcoal-_Vegas_Gold.jpg?v=1751643789' },
  "Navy Camo/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy_Camo-_White.jpg?v=1751643789' },
  "White Camo/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White_Camo-_White.jpg?v=1751643789' },
  "Green Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Green_Camo.jpg?v=1751485892' },
  "Grey Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey_Camo.jpg?v=1751485892' },
  "Heather Dark Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Dark_Royal.jpg?v=1751485892' },
  "Neon Fuchsia": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Neon_Fuchsia.jpg?v=1751485892' },
  "Azure Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Azure_Blue.jpg?v=1751485397' },
  "Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Khaki.jpg?v=1751485143' },
  "Stone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Stone.jpg?v=1751485143' },
  "Black/ White/ Grey/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_White_Grey_Red.jpg?v=1751484734' },
  "Maroon/ White/ Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Maroon_White_Grey.jpg?v=1751484734' },
  "Navy/ White/ Grey/ Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy_White_Grey_Gold.jpg?v=1751484734' },
  "Blaze Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Blaze_Orange.jpg?v=1751485074' },
  "Safety Yellow": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Safety_Yellow.jpg?v=1751485074' },
  "Navy/ White/ Grey/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy_White_Grey_Red.jpg?v=1751484734' },
  "Red/ White/ Grey/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red_White_Grey_Black.jpg?v=1751484734' },
  "Royal/ White/ Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal_White_Grey.jpg?v=1751484734' },
  "Navy/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-_Red.jpg?v=1751484495' },
  "Navy/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-White.jpg?v=1751484495' },
  "Royal/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal-White.jpg?v=1751484495' },
   "Apple": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Apple.jpg?v=1751402430' },
   "Ballerina": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ballerina.jpg?v=1751402429' },
   "Black/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/BlackBlack.jpg?v=1751484098' },
   "Dark Olive Green/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Olive_Green-_Khaki.jpg?v=1751484098' },
   "Navy/ Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Grey.jpg?v=1751484098' },
   "Old Wash Black/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Old_Wash_Black-Black.jpg?v=1751484098' },
   "Old Wash Grey/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Old_Wash_Grey-_Black.jpg?v=1751484098' },
   "Old Wash Navy/ Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Old_Wash_Navy-_Grey.jpg?v=1751484098' },
   "Banana": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Banana.jpg?v=1751402429' },
  "Cardinal/ Stone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cardinal-Stone.jpg?v=1751480554' },
  "Charcoal/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-_Black.jpg?v=1751480553' },
  "Forest Green/ Stone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Forest_Green-Stone.jpg?v=1751480553' },
  "Grey/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-Black.jpg?v=1751480553' },
  "Khaki/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Khaki-Black.jpg?v=1751480553' },
  "Navy/ Stone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Stone-Navy.jpg?v=1751480553' },
  "Red/ Stone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red-Stone.jpg?v=1751480553' },
  "Royal/ Stone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal-Stone.jpg?v=1751480553' },
  "Sky Blue/ Stone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sky_Blue-Stone.jpg?v=1751480553' },
  "Stone/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Stone-Navy.jpg?v=1751480553' },
  "Black/ Stone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Stone.jpg?v=1751480343' },
   "Caribbean": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Caribbean.jpg?v=1751402430' },
   "Cobalt": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cobalt.jpg?v=1751402429' },
   "Key Lime": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Key-Lime.jpg?v=1751402430' },
  "Coyote Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Coyote-Brown.jpg?v=1751399853' },
  "Granite Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Granite-Heather.jpg?v=1751399853' },
  "Rouge": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Rouge.jpg?v=1751399853' },
  "Bamboo Blackout": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Bamboo-Blackout.jpg?v=1751402014' },
  "Bermuda Blackout": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Bermuda-Blackout.jpg?v=1751402015' },
  "Storm Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Storm-Camo.jpg?v=1751402014' },
  "Vintage Hot Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Hot-Pink.jpg?v=1751402014' },
  "Haze Tie Dye": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Haze-Tie-Dye.jpg?v=1751401753' },
  "Island Tie Dye": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Island-Tie-Dye.jpg?v=1751401753' },
  "Rose Tie Dye": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Rose-Tie-Dye.jpg?v=1751401753' },
  "Sky Tie Dye": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sky-Tie-Dye.jpg?v=1751401753' },
  "Black Leopard": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Leopard.jpg?v=1751401239' },
  "Mauvelous Spot": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mauvelous-Spot.jpg?v=1751401239' },
  "Rainbow Stripe": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Rainbow-Stripe.jpg?v=1751401239' },
  "Shadow Stripe": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Shadow-Stripe.jpg?v=1751401239' },
  "Tradewind Spot": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tradewind-Spot.jpg?v=1751401239' },
  "White Spot": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Spot.jpg?v=1751401239' },
  "Chill": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chill.jpg?v=1751400697' },
  "Titanium": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Titanium.jpg?v=1751400697' },
  "Vintage Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Camo.jpg?v=1751399853' },
  "Vintage Smoke": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Smoke.jpg?v=1751399853' },
  "Mauvelous": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mauvelous.jpg?v=1751399473' },
  "Natural Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Heather.jpg?v=1751399473' },
  "Saltwater": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Saltwater.jpg?v=1751399473' },
  "Heather Grey/ Cancun": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Grey--Cancun.jpg?v=1751317333' },
  "Ash": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ash.jpg?v=1751310039' },
  "Heather Light Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Light-Pink.jpg?v=1751318250' },
  "Ice Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ice-Blue.jpg?v=175131825' },
  "Heather Light Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Light-Pink.jpg?v=1751318250' },
  "Cool Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cool-Blue.jpg?v=1751310717' },
  "Shiraz": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Shiraz.jpg?v=1751310040' },
  "Banana Cream": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Banana-Cream.jpg?v=1751314189' },
  "Bondi Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Bondi-Blue.jpg?v=1751314189' },
  "Silk": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Silk.jpg?v=1751314189' },
   "Envy Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Envy-Sleeves--Heather-White-Body.jpg?v=1751316500' },
   "Envy Sleeves/ Premium Heather Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Envy-Sleeves-Premium-Heather-Body.jpg?v=1751316500' },
   "Heather White/ Vintage Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-White--Vintage-Black.jpg?v=1751316500' },
   "Indigo Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Indigo-Sleeves-Heather-White-Body.jpg?v=1751316500' },
   "Premium Heather Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Premium-Heather-Sleeves-Heather-White-Body.jpg?v=1751316500' },
   "Premium Heather Sleeves/ Vintage Black Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Premium-Heather-Sleeves-Vintage-Black-Body.jpg?v=1751316500' },
   "Purple Rush Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Purple-Rush-Sleeves--Heather-White-Body.jpg?v=1751316500' },
   "Tahiti Blue Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tahiti-Blue-Sleeves--Heather-White-Body.jpg?v=1751316500' },
   "Vintage Black Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Black-Sleeves--Heather-White-Body.jpg?v=1751316500' },
   "Vintage Black Sleeves/ Premium Heather Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Black-Sleeves-Premium-Heather-Body.jpg?v=1751316500' },
   "Vintage Black Sleeves/ Vintage Black Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Black-Sleeves--Vintage-Black-Body.jpg?v=1751316500' },
   "Vintage Navy Sleeves/ Premium Heather Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Navy-Sleeves--Premium-Heather-Body.jpg?v=1751316500' },
   "Vintage Pink Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Pink-Sleeves--Heather-White-Body.jpg?v=1751316500' },
   "Vintage Purple Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Purple-Sleeves--Heather-White-Body.jpg?v=1751316500' },
   "Vintage Red Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Red-Sleeves-Heather-White-Body.jpg?v=1751316500' },
   "Vintage Red Sleeves/ Premium Heather Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Red-Sleeves-Premium-Heather-Body.jpg?v=1751316500' },
   "Vintage Red Sleeves/ Vintage Black Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Red-Sleeves--Vintage-Black-Body.jpg?v=1751316500' },
   "Vintage Royal Sleeves/ Heather White Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Royal-Sleeves--Heather-White-Body.jpg?v=1751316500' },
   "Vintage Royal Sleeves/ Premium Heather Body": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Royal-Sleeves-Premium-Heather-Body.jpg?v=1751316500' },
   "Envy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Envy.jpg?v=1751311895' },
  "Washed Banana Cream": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Banana-Cream.jpg?v=1751313017' },
  "Washed Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Black.jpg?v=1751313017' },
  "Washed Cardinal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Envy.jpg?v=1751311895' },
  "Washed Graphite Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Graphite-Black.jpg?v=1751313017' },
  "Washed Mauve": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Mauve.jpg?v=1751313017' },
  "Washed Military Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Military-Green.jpg?v=1751313017' },
  "Washed Natural": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Natural.jpg?v=1751313017' },
  "Washed Purple Rush": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Purple-Rush.jpg?v=1751313017' },
  "Washed Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Royal.jpg?v=1751313017' },
  "Washed Royal Pine": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Royal-Pine.jpg?v=1751313017' },
  "Washed Stonewash Denim": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-Stonewash-Denim.jpg?v=1751313017' },
  "Washed White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Washed-White.jpg?v=1751313017' },
   "Heather White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-White.jpg?v=1751311895' },
   "Indigo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Indigo.jpg?v=1751311895' },
  "Cancun": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cancun.jpg?v=1751312487' },
   "Premium Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Premium-Heather.jpg?v=1751311895' },
   "Venetian Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Venetian-Grey.jpg?v=1751311895' },
   "Vintage Light Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Light-Orange.jpg?v=1751311896' },
   "Vintage Lilac": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Lilac.jpg?v=1751311895' },
   "Vintage Purple": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Purple.jpg?v=1751311895' },
   "Vintage Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Royal.jpg?v=1751311895' },
   "Vintage Shocking Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Shocking-Pink.jpg?v=1751311895' },
   "Vintage Turquoise": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Turquoise.jpg?v=1751311895' },
  "Cancun": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Turquoise.jpg?v=1751311895' },
  "Smoked Paprika": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Smoked-Paprika.jpg?v=1751310040' },
  "Stonewash Denim": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Stonewash-Denim.jpg?v=1751310040' },
  "Stonewash Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Stonewash-Green.jpg?v=1751310039' },
  "Purple Rush": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Purple-Rush.jpg?v=1751310468' },
  "Tahiti Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tahiti-Blue.jpg?v=1751310468' },
  'Burgundy': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Burgundy.jpg?v=1750452510' },
  'Silver': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/silver.jpg?v=1750452510' },
  "Grey/ Maroon Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-Maroon-Triblend.gif?v=1750005359' },
  "Heather Slate Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Slate-Blue.jpg?v=1751309619' },
  "Cardinal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cardinal.jpg?v=1750793646' },
  "Heather Bay Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Bay-Blue.jpg?v=1751308839' },
  "Heather Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Black.jpg?v=1751308839' },
  "Heather Midnight Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Midnight-Navy.jpg?v=1751308839' },
  "Heather Military Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Military-Green.jpg?v=1751308839' },
  "Heather Teal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Teal.jpg?v=1751308839' },
  "Canyon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Canyon.jpg?v=1750793646' },
   "Heather Forest Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Forest-Green.jpg?v=1751307942' },
   "Heather Metal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Metal.jpg?v=1751307943' },
   "Heavy Metal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heavy-Metal.jpg?v=1751303584' },
   "Lead Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lead-Grey.jpg?v=1751303584' },
  "Creme": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Creme.jpg?v=1750793646' },
  "Antique Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Antique-Gold.jpg?v=1751303280' },
  "Dark Heather Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark-Heather-Grey.jpg?v=1751303279' },
  "Faded Army": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Faded-Army.jpg?v=1750795718' },
   "Midnight Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Midnight-Navy.jpg?v=1751301754' },
  "Desert Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Desert-Pink.jpg?v=1751302381' },
  "Oatmeal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Oatmeal.jpg?v=1751302381' },
  "Graphite Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Graphite-Black.jpg?v=1751302915' },
  "Light Olive": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Light-Olive.jpg?v=1751302915' },
  "Shiitake": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Shiitake.jpg?v=1751302915' },
  "Royal Pine": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal-Pine.jpg?v=1751302381' },
  "Faded Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Faded-Black.jpg?v=1750795719' },
  "Faded Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Faded-Brown.jpg?v=1750795718' },
  "Faded Cream": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Faded-Cream.jpg?v=1750795719' },
  "Faded Mustard": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Faded-Mustard.jpg?v=1750795719' },
  "Faded Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Faded-Navy.jpg?v=1750795718' },
  "True Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/True-Black.jpg?v=1750797960' },
  "Bone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Bone.jpg?v=1750786197' },
  "Tri-Coral": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Coral.jpg?v=1750793448' },
  "Tri-Cream": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Cream.jpg?v=1750793448' },
  "Tri-Dusk": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Dusk.jpg?v=1750793448' },
  "Tri-Olive": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Olive.jpg?v=1750793447' },
  "Tri-Rust": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Rust.jpg?v=1750793447' },
  "Tri-Storm": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Storm.jpg?v=1750793448' },
  "Sueded Arctic": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sueded-Arctic.jpg?v=1750787061' },
  "Sueded Asphalt": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sueded-Asphalt.jpg?v=1750787061' },
  "Sueded Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sueded-Black.jpg?v=1750787061' },
  "Sueded Lieutenant": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sueded-Lieutenant.jpg?v=1750787061' },
  "Sueded Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sueded-Navy.jpg?v=1750787061' },
  "Sueded White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sueded-White.jpg?v=1750787061' },
  "Gravel": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Gravel.jpg?v=1750786197' },
  "Rust": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Rust.jpg?v=1750787639' },
  "Smokey Violet": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Smokey-Violet.jpg?v=1750787639' },
  "Heather Bone/ Heather Army": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Bone--Heather-Army.jpg?v=1750787405' },
  "White/ Heather Cardinal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Cardinal.jpg?v=1750787405' },
  "White/ Heather Indigo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White--Heather-Indigo.jpg?v=1750787405' },
  "White/ Heather Mustard": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Mustard.jpg?v=1750787405' },
  "White/Heather Arctic": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Arctic.jpg?v=1750787405' },
  "Heather Lilac": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Lilac.jpg?v=1750786391' },
  "Army": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Army.jpg?v=1750784285' },
  "Powder Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Powder-Blue.jpg?v=1750787551' },
  "Cream": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cream.jpg?v=1750785139' },
  "Blush": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Blush.jpg?v=1750787768' },
   "Arctic": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Arctic.jpg?v=1750786758' },
  "Celadon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Celadon.jpg?v=1750786624' },
  "Eggplant": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Eggplant.jpg?v=1750786623' },
  "Super Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Super-Pink.jpg?v=1750786624' },
  "Lieutenant": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lieutenant.jpg?v=1750785139' },
  "Heather Arctic": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Arctic.jpg?v=1750785805' },
  "Heather Army": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Army.jpg?v=1750785804' },
  "Heather Blush": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Blush.jpg?v=1750785804' },
  "Heather Bone": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Bone.jpg?v=1750785804' },
  "Heather Cardinal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/American-Apparel.jpg?v=1750785804' },
  "Heather Indigo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Indigo.jpg?v=1750785804' },
  "Heather Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Khaki.jpg?v=1750785804' },
  "Sea Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sea-Blue.jpg?v=1750785139' },
  "Athletic Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Grey.jpg?v=1750784416' },
  "Tri-Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Black.jpg?v=1750784416' },
  "Tri-Evergreen": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Evergreen.jpg?v=1750784416' },
  "Tri-Oatmeal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Oatmeal.jpg?v=1750784416' },
  "Ash Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ash-Grey.jpg?v=1750783023' },
  "Truffle": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Truffle.jpg?v=1750784733' },
  "Aqua": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Aqua.jpg?v=1750784038' },
  "Grass": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grass.jpg?v=1750784038' },
  "New Silver": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/New-Silver.jpg?v=1750784038' },
  "Sunshine": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sunshine.jpg?v=1750784039' },
  "Athletic Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Blue.jpg?v=1750783557' },
  "Tri-Coffee": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Coffee.jpg?v=1750783557' },
  "Tri-Cranberry": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Cranberry.jpg?v=1750783557' },
  "Tri-Indigo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Indigo.jpg?v=1750783557' },
  "Tri-Lemon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Lemon.jpg?v=1750783557' },
  "Tri-Orchid": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tri-Orchid.jpg?v=1750783558' },
  "Cranberry": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cranberry.jpg?v=1750783023' },
  "Lapis": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lapis.jpg?v=1750783023' },
  "Lemon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lemon.jpg?v=1750783023' },
   "Aruba Blue/ Birch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Aruba_Blue-_Birch.jpg?v=1751746042' },
   "Black/ Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-_Charcoal.jpg?v=1751746042' },
   "Black/ Neon Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-_Neon_Pink.jpg?v=1751746042' },
   "Brown/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brown-_Khaki.jpg?v=1751746042' },
   "Carmel/ Birch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Carmel-Birch.jpg?v=1751746042' },
   "Carmel/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Carmel-Black.jpg?v=1751746042' },
   "Charcoal/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-Red.jpg?v=1751746042' },
   "Chocolate Chip/ Grey Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chocolate_Chip-_Grey_Brown.jpg?v=1751746042' },
   "Coffee/ Claret": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Coffee-Claret.jpg?v=1751746042' },
  "Black/ Grey/ Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Grey_Charcoal.jpg?v=1751824539' },
  "Navy/ Grey/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy_Grey_White.jpg?v=1751824540' },
  "Olive/ Khaki/ Light Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Olive_Khaki_Light_Khaki.jpg?v=1751824539' },
  "Pink/ Grey/ Light Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pink_Grey_Light_Pink.jpg?v=1751824540' },
  "Red/ Grey/ Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red_Grey_Charcoal.jpg?v=1751824539' },
  "Moss Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Moss_Green.jpg?v=1751824863' },
  "Cream/ Mocha": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cream_Mocha.jpg?v=1751825157' },
  "Heather Grey/ Rust": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey_Rust.jpg?v=1751825157' },
  "Charcoal Grey Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal_Grey_Heather.jpg?v=1751920484' },
   "Cream/ Loden Green/ Dark Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cream_Loden_Green_Dark_Orange.jpg?v=1751746042' },
   "Cyan/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cyan-_Black.jpg?v=1751746042' },
   "Mocha": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mocha.jpg?v=1751922200' },
   "Shadow": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Shadow.jpg?v=1751922201' },
   "Dark Loden/ Jaffa Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Loden-_Jaffa_Orange.jpg?v=1751746042' },
   "Dark Orange/ Birch/ Patriot Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Orange_Birch_Patriot_Blue.jpg?v=1751746042' },
   "Heather Dark Green/ Silver": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Dark_Green-Silver.jpg?v=1751746042' },
   "Heather Grey/ Birch/ Amber Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey_Birch_Amber_Gold.jpg?v=1751746042' },
   "Heather Grey/ Birch/ Army": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey_Birch_Army.jpg?v=1751746042' },
   "Heather Grey/ Birch/ Cardinal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey_Birch_Cardinal.jpg?v=1751746042' },
   "Heather Grey/ Dark Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_Dark_Charcoal.jpg?v=1751746042' },
   "Heather Navy/ Light Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Navy_Light_Grey.jpg?v=1751746042' },
   "Heather Red/ Light Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Red-_Light_Grey.jpg?v=1751746042' },
   "Heather Royal/ Light Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Royal-_Light_Grey.jpg?v=1751746042' },
   "Hot Pink/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Hot_Pink-_Black.jpg?v=1751746042' },
   "Lilac/ Birch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lilac-Birch.jpg?v=1751746042' },
  "Khaki/ Loden": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Khaki_Loden.jpg?v=1751822982' },
  "Olive/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Olive_Black.jpg?v=1751824362' },
   "Loden": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Loden.jpg?v=1751746042' },
  "Birch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Birch.jpg?v=1751823405' },
   "Olive Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Olive_Green.jpg?v=1751823048' },
   "Wheat": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Wheat.jpg?v=1751823048' },
  "Amber Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Amber_Gold.jpg?v=1751822903' },
  "Caramel/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Caramel_Black.jpg?v=1751822903' },
  "Heather Grey/ Birch/ Loden": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey_Birch_Loden.jpg?v=1751822902' },
  "Charcoal/ Cyan": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal_Cyan.jpg?v=1751822131' },
  "Teal/ Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Teal_Orange.jpg?v=1751822131' },
  "White/ Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White_Charcoal.jpg?v=1751821623' },
  "White/ Navy/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White_Navy_Red.jpg?v=1751821623' },
   "Loden/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Loden-_Khaki.jpg?v=1751814400' },
  "Light Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Light_Navy.jpg?v=1751814203' },
  "Moss": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Moss.jpg?v=1751814203' },
  "Army Olive": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Army_Olive.jpg?v=1751821404' },
  "Flint Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Flint_Grey.jpg?v=1751821404' },
  "Military Digital Camo/ Light Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Military_Digital_Camo_Light_Green.jpg?v=1751816700' },
  "Mossy Oak Bottomland/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mossy_Oak_Bottomland_Black.jpg?v=1751816699' },
  "Mossy Oak Country DNA/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mossy_Oak_Country_DNA_Black.jpg?v=1751816700' },
  "Mossy Oak Obsession/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mossy_Oak_Obsession_Khaki.jpg?v=1751816699' },
  "Realtree Edge/ Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Realtree_Edge_Brown.jpg?v=1751816699' },
  "Realtree Max 7/ Buck": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Realtree_Max_7_Buck.jpg?v=1751816699' },
  "Realtree Timber/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Realtree_Timber_Black.jpg?v=1751816699' },
  "Shadow Grass Habitat/ Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Shadow_Grass_Habitat-_Brown.jpg?v=1751816700' },
  "Black/ Charcoal Split": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-_Charcoal_Split.jpg?v=1751815523' },
  "Black/ White Split": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-_White_Split.jpg?v=1751815523' },
  "Charcoal/ Black Split": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-_Charcoal_Split.jpg?v=1751815523' },
  "Charcoal/ White Split": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-_White_Split.jpg?v=1751815523' },
  "Grey/ White/ Black Tri": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy_White_Red_Tri.jpg?v=1751815523' },
  "Red/ Charcoal/ Black Tri": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red_Charcoal_Black_Tri.jpg?v=1751815523' },
  "Royal/ Charcoal/ Black Tri": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal_Charcoal_Black_Tri.jpg?v=1751815523' },
  "White/ Royal/ Red Tri": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White_Royal_Red_Tri.jpg?v=1751815523' },
  "Navy/ White Split": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-White_Split.jpg?v=1751815523' },
  "Navy/ White/ Red Tri": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy_White_Red_Tri.jpg?v=1751815523' },
  "Pool Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pool_Blue.jpg?v=1751814203' },
  "Black/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-_Khaki.jpg?v=1751754823' },
  "Columbia Blue/ Charcoal/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Columbia_Blue-_Charcoal-_Navy.jpg?v=1751754823' },
  "Columbia Blue/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Columbia_Blue-_Khaki.jpg?v=1751754823' },
  "Driftwood/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Driftwood-_Khaki.jpg?v=1751754823' },
  "Pink/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pink-_White.jpg?v=1751754823' },
  "Red/ Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red-_Charcoal.jpg?v=1751754823' },
  "Red/ Charcoal/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red_Charcoal_Black.jpg?v=1751754823' },
  "Royal/ Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal-Charcoal.jpg?v=1751754823' },
  "Texas Orange/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Texas_Orange-Khaki.jpg?v=1751754823' },
  "Biscuit/ True Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Biscuit-_True_Blue.jpg?v=1751749661' },
  "Black/ Vegas Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Vegas_Gold.jpg?v=1751749660' },
  "Black/ White/ Heather Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-_White-_Heather_Grey.jpg?v=1751749661' },
  "Black/ White/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-_White-Red.jpg?v=1751749660' },
  "Cardinal/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cardinal-Black.jpg?v=1751749660' },
  "Charcoal/ Columbia Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-_Columbia_Blue.jpg?v=1751749660' },
  "Charcoal/ Kelly": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-_Kelly.jpg?v=1751749661' },
  "Charcoal/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-Navy.jpg?v=1751749661' },
  "Charcoal/ Neon Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-_Neon_Blue.jpg?v=1751749660' },
  "Charcoal/ Neon Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-_Neon_Green.jpg?v=1751749660' },
  "Charcoal/ Neon Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-_Neon_Orange.jpg?v=1751749661' },
  "Charcoal/ Neon Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-_Neon_Pink.jpg?v=1751749660' },
  "Charcoal/ Neon Yellow": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-Neon_Yellow.jpg?v=1751749660' },
  "Charcoal/ Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-Orange.jpg?v=1751749660' },
  "Charcoal/ Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-Royal.jpg?v=1751749660' },
  "Columbia Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Columbia_Blue.jpg?v=1751749660' },
  "Columbia Blue/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Columbia_Blue-White.jpg?v=1751749660' },
  "Columbia Blue/ White/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Columbia_Blue-_White-_Navy.jpg?v=1751749660' },
  "Cyan/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cyan-_White.jpg?v=1751749660' },
  "Dark Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Green.jpg?v=1751749660' },
  "Black/ Black to White Fade": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-_Black_to_White_Fade.jpg?v=1751754199' },
  "Brown/ Desert Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brown-_Desert_Camo.jpg?v=1751754199' },
  "Green Camo/ Stars & Stripes": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Green_Camo_Stars_Stripes.jpg?v=1751754199' },
  "Heather Grey/ Stars & Stripes": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_Stars_Stripes.jpg?v=1751754199' },
  "Loden/ Green Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Loden-_Green_Camo.jpg?v=1751754199' },
  "Mossy Oak Break-Up Country/ Stars & Stripes": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mossy_Oak_Break-Up_Country-_Stars_Stripes.jpg?v=1751754199' },
  "Navy/ Navy to White Fade": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Navy_to_White_Fade.jpg?v=1751754199' },
  "Silver/ Grey Camo": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Silver-Grey_Camo.jpg?v=1751754199' },
  "Black/ Camo/ Loden": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-_Camo-Loden.jpg?v=1751751541' },
  "Caramel": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Caramel.jpg?v=1751751541' },
   "Green Camo/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Green_Camo_Black.jpg?v=1751752170' },
   "Heather Charcoal/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Charcoal_White.jpg?v=1751752170' },
   "Heather Grey/ Birch/ Biscuit": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey_Birch_Biscuit.jpg?v=1751752170' },
   "Navy/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-_Navy.jpg?v=1751752170' },
  "Black/ Graphite": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Graphite.jpg?v=1751751933' },
  "Charcoal/ Black/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal_Black_White.jpg?v=1751751541' },
  "Charcoal/ Burnt Orange/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal_Burnt_Orange_Black.jpg?v=1751751541' },
  "Charcoal/ Old Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal_Old_Gold.jpg?v=1751751541' },
  "Dark Green/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Green_Black.jpg?v=1751751541' },
  "Loden Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Loden_Green.jpg?v=1751751541' },
  "Dark Green/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark_Green-White.jpg?v=1751749661' },
  "Grey/ Charcoal/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey_Charcoal_Black.jpg?v=1751749660' },
  "Grey/ Charcoal/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-_Charcoal-_Navy.jpg?v=1751749660' },
  "Heather Grey/ Charcoal/ Dark Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_Charcoal-_Dark_Orange.jpg?v=1751749660' },
  "Heather Grey/ Charcoal/ Maroon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_Charcoal-_Maroon.jpg?v=1751749660' },
  "Heather Grey/ Dark Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-Dark_Green.jpg?v=1751749660' },
  "Heather Grey/ Light Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_Light_Grey.jpg?v=1751749660' },
  "Heather Grey/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-Navy.jpg?v=1751749660' },
  "Heather Grey/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-Red.jpg?v=1751749660' },
  "Heather Grey/ Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_Royal.jpg?v=1751749660' },
  "Heather Grey/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather_Grey-_White.jpg?v=1751749661' },
  "Hot Pink/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Hot_Pink-White.jpg?v=1751749660' },
  "Kelly/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Kelly-_White.jpg?v=1751749661' },
  "Khaki/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Khaki-White.jpg?v=1751749660' },
  "Loden/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Loden-Black.jpg?v=1751749660' },
  "Maroon/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Maroon-White.jpg?v=1751749660' },
  "Mink Beige/ Charcoal/ Amber Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mink_Beige-Charcoal-Amber_Gold.jpg?v=1751749660' },
  "Navy/ Carmel": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Carmel.jpg?v=1751749660' },
  "Navy/ Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Charcoal.jpg?v=1751749660' },
  "Navy/ Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Orange.jpg?v=1751749660' },
  "Navy/ White/ Heather Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-White-Heather_Grey.jpg?v=1751749661' },
  "Navy/ White/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-White-Red.jpg?v=1751749660' },
  "Orange/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Orange-Black.jpg?v=1751749660' },
  "Orange/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Orange-White.jpg?v=1751749660' },
  "Orange/ White/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Orange-White-Black.jpg?v=1751749660' },
  "Purple/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Purple-White.jpg?v=1751749661' },
  "Red/ White/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red-White-Black.jpg?v=1751749660' },
  "Red/ White/ Heather Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red_White_Heather_Grey.jpg?v=1751749660' },
  "Red/ White/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red-White-Navy.jpg?v=1751749660' },
  "Royal/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal-_Black.jpg?v=1751749660' },
  "Royal/ White/ Heather Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal_White_Heather_Grey.jpg?v=1751749660' },
  "Royal/ White/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal_White_Red.jpg?v=1751749660' },
  "White/ Columbia Blue/ Yellow": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White_Columbia_Blue_Yellow.jpg?v=1751749660' },
   "Navy/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy_Khaki.jpg?v=1751746042' },
   "Pale Banana/ Birch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pale_Banana-_Birch.jpg?v=1751746042' },
   "Patina Green/ Birch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Patina_Green-_Birch.jpg?v=1751746042' },
   "Smoke Blue/ Aluminum": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Smoke_Blue-_Aluminum.jpg?v=1751746042' },
   "Spruce/ Birch/ Light Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spruce-_Birch-_Light_Navy.jpg?v=1751746042' },
   "Sunkissed Peach/ Birch": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sunkissed_Peach-_Birch.jpg?v=1751746042' },
   "Tan/ Loden/ Brown": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tan_Loden_Brown.jpg?v=1751746042' },
   "White/ Blue Hawaiin/ Pale Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White_Blue_Hawaiin_Pale_Orange.jpg?v=1751746042' },
   "Black Aqua": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Aqua.jpg?v=1750783308' },
   "Heather Kelly Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Kelly-Green.jpg?v=1750783308' },
  "Natural/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Black.jpg?v=1750537161' },
  "Natural/ Light Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Light-Pink.jpg?v=1750537161' },
  "Natural/ Lime": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Lime.jpg?v=1750537161' },
  "Natural/ Maroon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural--Maroon.jpg?v=1750537161' },
  "Natural/ Natural": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/natural.jpg?v=1750537161' },
  "Natural/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Navy.jpg?v=1750537161' },
  "Natural/ Purple": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Purple.jpg?v=1750537161' },
  "Natural/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural--Red.jpg?v=1750537161' },
  "Natural/ Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Royal.jpg?v=1750537161' },
  "Texas Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Texas-Orange.jpg?v=1750537473' },
  "Lime": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/LIME.jpg?v=1750535463' },
  "Lavender": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lavender.jpg?v=1750535590' },
  "Black/ Natural/ Light Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black--Natural--Light-Grey.jpg?v=1750536105' },
  "Chocolate/ Natural/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chocolate--Natural-Khaki.jpg?v=1750536105' },
  "Forest/ Natural/ Khaki": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Forest-Natural-Khaki.jpg?v=1750536105' },
  "Maroon/ Natural/ Light Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Maroon-Natural-light-Pink.jpg?v=1750536105' },
  "Navy/ Natural/ Carolina Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Natural-Carolina-Blue.jpg?v=1750536105' },
  "Navy/ Natural/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Natural-Red.jpg?v=1750536105' },
  "Purple/ Natural/ Lavender": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Purple-Natural-Lavender.jpg?v=1750536105' },
  "Hot Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Hot-Pink.jpg?v=1750534617' },
  "Navy Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Blue.jpg?v=1750534926' },
  "Cloudy Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cloudy-Blue.jpg?v=1750535222' },
  "Cotton Candy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cotton-Candy.jpg?v=1750535222' },
  "Pink Lady": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pink-Lady.jpg?v=1750535221' },
  "Stormy Ash": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Stormy-Ash.jpg?v=1750535221' },
  "Lime Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lime-Green.jpg?v=1750534617' },
  "Heather Charcoal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Charcoal.jpg?v=1750452687' },
  "Kelly Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Kelly-Green.jpg?v=1750452687' },
  "Grey/ Navy Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey--Navy-Triblend.gif?v=1750005359' },
  "Heather Charcoal/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Charcoal-Black.jpg?v=1750452877' },
  "White/ Heather Peach": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Peach.gif?v=1750005359' },
  "White/ True Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-True-Royal.gif?v=1750005359' },
   "Steel Grey": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Steel-Grey.jpg?v=1750534194' },
  "White/ Kelly": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Kelly.gif?v=1750005359' },
  "White/ Maroon": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Maroon.gif?v=1750005359' },
  "White/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Navy_28adae0a-ad8e-4406-8f40-dde52bb12ed5.gif?v=1750005359' },
  "White/ Neon Orange": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Neon-Orange.gif?v=1750005359' },
  "White/ Neon Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Neon-Pink.gif?v=1750005359' },
  "White/ Neon Yellow": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Neon-Yellow.gif?v=1750005359' },
  "White/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Red.gif?v=1750005359' },
  "White/ Denim": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Denim.gif?v=1750005359' },
  "White/ Heather Olive": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Olive.gif?v=1750005359' },
  "Grey/ Red Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-Red-Triblend.gif?v=1750005359' },
  "Grey/ True Royal Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-True-Royal-Triblend.gif?v=1750005359' },
  "White Fleck/ Charcoal Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Fleck--Charcoal-Triblend.gif?v=1750005359' },
  "White Fleck/ Navy Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Fleck-Navy-Triblend.gif?v=1750005359' },
  "White/ Asphalt": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Asphalt.gif?v=1750005359' },
  "White/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Black.gif?v=1750005359' },
  "White/ Deep Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White--Deep-Heather.gif?v=1750005359' },
  "Sport Grey/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sport-Grey-Black.gif?v=1749939676' },
  "Asphalt Slub": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Asphalt-Slub.jpg?v=1750274018' },
  "Peach": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Peach.jpg?v=1750274329' },
  "Cardinal Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cardinal-Triblend.jpg?v=1750274468' },
   "Black Mineral Wash": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Mineral-Wash_1409c42f-9170-4430-9bbc-a7ce5601fae5.jpg?v=1750274837' },
  "Black Heather Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Heather-Triblend.jpg?v=1750274647' },
  "Sport Grey/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sport-Grey-Navy.gif?v=1749939677' },
  "Sport Grey/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sport-Grey--Red.gif?v=1749939676' },
  "Athletic Heather/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Heather-Black.jpg?v=1750275857' },
  "Deep Heather/ Dark Grey Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Deep-Heather--Dark-Grey-Heather.jpg?v=175027610' },
  "White/ Baby Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White--Baby-Blue.jpg?v=1750275857' },
  "White/ Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White--Pink.jpg?v=1750275857' },
   "Athletic Heather/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Heather--Navy.jpg?v=1750275150' },
  "Heather Red/ Deep Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Red--Deep-Heather.jpg?v=1750275150' },
  "Heather True Royal/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-True-Royal-Navy.jpg?v=1750275150' },
   "White/ Athletic Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Athletic-Heather.jpg?v=1750275151' },
  "Dark Grey Heather/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark-Grey-Heather-Black.jpg?v=1750275150' },
  "Sport Grey/ Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sport-Grey-Royal.gif?v=1749939676' },
  "White/ Forest Green": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Forest-Green.gif?v=1749939676' },
   "Black Mineral Wash": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Mineral-Wash.jpg?v=1750272684' },
   "Charcoal Black Slub": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-Black-Slub.jpg?v=1750272684' },
   "Denim Slub": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Denim-Slub_bb01f9ba-d449-462b-ac23-8e20c7ac931c.jpg?v=1750272684' },
   "Forest Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Forest-Marble.jpg?v=1750272684' },
   "Maroon Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Maroon-Marble.jpg?v=1750272684' },
   "Navy Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Marble.jpg?v=1750272684' },
   "Navy Slub": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Slub_d001c011-94ff-4c72-a939-d2c4013a8de1.jpg?v=1750272684' },
   "Olive Slub": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Olive-Slub.jpg?v=1750272684' },
   "Solid Black Slub": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Solid-Black-Slub.jpg?v=1750272684' },
   "Stone Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Stone-Marble.jpg?v=1750272684' },
  "White/ Heliconia": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heliconia.gif?v=1749939676' },
  "White/ Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Navy.gif?v=1749939676' },
   "White/ Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Royal.gif?v=1749939676' },
  "Black Heather/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Heather-Black.gif?v=1750006417' },
  "Black Marble/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Marble-Black.gif?v=1750006418' },
  "Black/ Deep Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Deep-Heather.gif?v=1750006417' },
    "Black/ Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Red.gif?v=1750006417' },
  "Black/ True Royal": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-True-Royal.gif?v=1750006418' },
"Black/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/black_white.jpg?v=1751742787' },
  "Deep Heather/ Black": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Deep-Heather--Black.gif?v=1750005359' },
  "Grey/ Charcoal Black Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey--Charcoal-Black-Triblend.gif?v=1750005359' },
  "Grey/ Emerald Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-Emerald-Triblend.gif?v=1750005359' },
'White/ Red': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Red.jpg?v=1749844579' },
'White/ Black': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Black.jpg?v=1749844746' },
'White/ Heather Peach': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Peach.jpg?v=1749845183' },
'Blue Marble': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Blue-Marble.jpg?v=1749845368' },
"Black Ink Heather/ Black Ink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Ink-Heather--Black-Ink.gif?v=1750102663' },
"Charcoal/ Black Ink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal--Black-Ink.jpg?v=1750282043' },
"Black Ink/ White": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Ink-White.gif?v=1750102663' },
"Charcoal Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-Marble.gif?v=1750265640' },
"True Royal Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/True-Royal-Marble.gif?v=1750265640' },
"Berry Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Berry-Triblend.gif?v=1750265819' },
"Red Marble": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red-Marble.jpg?v=1750265963' },
"Solid Black Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Solid-Black-Triblend.jpg?v=1750269622' },
"Solid White Triblend": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Solid-White-Triblend.jpg?v=1750269622' },
"Sweet Cream Heather/ Blush Pink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sweet-Cream-Heather-Blush-Pink.gif?v=1750102663' },
"Sweet Cream Heather/ Heather Mauve": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sweet-Cream-Heather-Heather-Mauve.gif?v=1750102663' },
"Sweet Cream Heather/ Indigo Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sweet-Cream-Heather-Indigo-Heather.gif?v=1750102663' },
  "White/ Black Ink": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Black-Ink.gif?v=1750102663' },
"Heather Yellow Gold": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Yellow-Gold.jpg?v=1750270188' },
"White/ Charcoal Heather": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White--Charcoal-Heather.gif?v=1750102663' },
"White/ J. Navy": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-J.-Navy.gif?v=1750102663' },
"White/ Scuba Blue": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Scuba-Blue.gif?v=1750102663' },
  "White/ True Red": { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-True-Red.gif?v=1750102663' },
'Black Marble': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Marble.jpg?v=1749846448' },
'White Marble': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Marble.jpg?v=1749843856' },
'Graphite Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Graphite-Heather.jpg?v=1749852538' },
'Sport Grey': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sport-Grey.jpg?v=1749854342' },
'Heather Red': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Red.jpg?v=1749854504' },
'Heather Grey': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Grey.jpg?v=1749854594' },
'Antique Gold Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Antique-Gold-Heather.jpg?v=1750451370' },
'Agave Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Agave-Heather.jpg?v=1750451370' },
'Athletic Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Heather.jpg?v=1750451370' },
   'Brown Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brown-Heather.jpg?v=1750451370' },
   'Burgundy Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Burgundy-Heather.jpg?v=1750451370' },
   'Cactus Flower Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cactus-Flower-Heather.jpg?v=1750451370' },
   'Kelly Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Kelly-Heather.jpg?v=1750451370' },
   'Navy Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Heather.jpg?v=1750451370' },
   'Olive Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Olive-Heather.jpg?v=1750451370' },
'Peach Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Peach-Heather.jpg?v=1750451370' },
   'Red Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Red-Heather.jpg?v=1750451371' },
  'Royal Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal-Heather.jpg?v=1750451371' },
  'Turquoise Heather': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Turquoise-Heather.jpg?v=1750451370' },
  'Athletic Blue Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Blue-Tri-Blend.jpg?v=1750454486' },
  'Berry Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Berry-Tri-Blend.jpg?v=1750454486' },
  'Graphite B': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Graphite-B.jpg?v=1750454486' },
  'Graphite Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Graphite-Tri-Blend.jpg?v=1750454486' },
  'Heather B': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-B.jpg?v=1750454486' },
  'Heather Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Tri-Blend.jpg?v=1750454486' },
  'Grape Leaf': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grape-Leaf.jpg?v=1750457270' },
  'Inked India': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Inked-India.jpg?v=1750457270' },
  'Lilac B': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lilac-B.jpg?v=1750454486' },
  'Lilac Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lilac-Tri-Blend.jpg?v=1750454486' },
  'Midnight Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Midnight-Tri-Blend.jpg?v=1750454486' },
  'Mocha Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mocha-Tri-Blend.jpg?v=1750454486' },
  'Seafoam Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Seafoam-Tri-Blend.jpg?v=1750454487' },
   'Heather Athletic Blue': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Athletic-Blue.jpg?v=1750455893' },
   'Heather Brown': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Brown.jpg?v=1750455893' },
   'Heather Fuchsia': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Fuchsia.jpg?v=1750455893' },
   'Heather Green': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Green.jpg?v=1750455893' },
   'Heather Orange': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Orange.jpg?v=1750455893' },
   'Heather Pink': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Pink.jpg?v=1750455893' },
  'Heather Light Blue': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Light-Blue.jpg?v=1750456328' },
  'Fuchsia': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Fuchsia.jpg?v=1750456692' },
  'Heather Denim': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Denim.jpg?v=1750456692' },
  'Heather Kelly': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Kelly.jpg?v=1750456559' },
  'Cardinal Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cardinal-Tri-Blend.jpg?v=1750457556' },
  'Denim Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Denim-Tri-Blend.jpg?v=1750457556' },
  'Graphite (disc)': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Graphite-_disc.jpg?v=1750457556' },
  'Heather (disc)': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-_disc.jpg?v=1750457556' },
  'Jade Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Jade-Tri-Blend.jpg?v=1750457556' },
  'Midnight B': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Midnight-B.jpg?v=1750457556' },
  'Military Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Military-Tri-Blend.jpg?v=1750457556' },
  'Brown': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brown.jpg?v=1750458041' },
  'Royal (disc)': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Royal-_disc.jpg?v=1750458313' },
  'Solid Black Tri Blend': { img: 'https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Solid-Black-Tri-Blend.jpg?v=1750457556' },
    "Midnight": { hex: "#191970" },
  "Heather Purple (disc)": { "hex": "#76617E" },
"Heather Royal": { "hex": "#6F98D8" },
  "Heather Royal (disc)": { "hex": "#456ABE" },
  "Amethyst": { "hex": "#9966CC" },
  "Aqua Triblend": { "hex": "#80b6a7" },
  "Heather Graphite": { "hex": "#4A5059" },
  "Cantaloupe": { "hex": "#FFB38E" },
"Mellow Yellow": { "hex": "#F9BB44" },
"Neo Mint": { "hex": "#CBECC2" },
"Purist Blue": { "hex": "#BAE6EF" },
  "Atlantic": { "hex": "#5a7882" },
  "Cloud Heather": { "hex": "#9eb5cb" },
  "Athletic Grey Triblend": { "hex": "#a4a7a8" },
  "Athletic Heather/Black": { "hex": "#898D8D" },
  "Azalea": { "hex": "#dd74a1" },
  "Baby Blue": { "hex": "#69b3e7" },
  "Berry": { "hex": "#A63A79" },
  "Black Heather": { "hex": "#2E2E2E" },
  "Black Ink": { "hex": "#292929" },
  "Black Ink Heather": { "hex": "#535456" },
  "Black Speckled": { "hex": "#3a3a3a" },
  "Black/Deep Heather": { "hex": "#4b4f54" },
  "Blue Dusk": { "hex": "#253746" },
  "Blue Jean": { "hex": "#5B6E7D" },
  "Blue Triblend": { "hex": "#5b7d9c" },
  "Blush Pink": { "hex": "#e1b4b3" },
  "Brick": { "hex": "#7f3338" },
  "Brown Savana": { "hex": "#8b7d6b" },
  "Burnt Orange": { "hex": "#cc5500" },
  "Butter": { "hex": "#F6E27F" },
  "Cactus": { "hex": "#788a7a" },
  "J. Navy": { "hex": "#2c3e50" },
  "California Blue": { "hex": "#0091B3" },
  "Cardinal Red": { "hex": "#9D2235" },
  "Caribbean Blue": { "hex": "#00a9ce" },
  "Caribbean Mist": { "hex": "#00a9ce" },
  "Carolina Blue": { "hex": "#7ba4db" },
  "Carolina Heather": { "hex": "#a3b4c6" },
  "Cement": { "hex": "#aeaeae" },
  "Chalky Mint": { "hex": "#A8E6CF" },
  "Chambray": { "hex": "#3C6382" },
  "Charcoal": { "hex": "#1e1e1e" },
  "Charcoal Black Triblend": { "hex": "#353631" },
  "Charcoal Grey": { "hex": "#737373" },
  "Charcoal/Black Ink": { "hex": "#4e4f51" },
  "Charity Pink": { "hex": "#f8a3bc" },
  "Charity Pink Triblend": { "hex": "#e789af" },
  "Cherry Red": { "hex": "#ac2b37" },
  "Citrine": { "hex": "#e4d00a" },
  "Classic Pink": { "hex": "#fbcadd" },
  "Clay": { "hex": "#b77f68" },
  "Cocoa": { "hex": "#5e4742" },
  "Coral": { "hex": "#ff7f50" },
  "Coral Silk": { "hex": "#fb637e" },
  "Crimson": { "hex": "#8C1C13" },
  "Crunchberry": { "hex": "#d95c81" },
  "Cyber Pink": { "hex": "#ff3399" },
  "Daisy": { "hex": "#fed101" },
  "Daisy Mist": { "hex": "#fed101" },
  "Dark Chocolate": { "hex": "#382f2d" },
  "Dark Grey": { "hex": "#4B4B4B" },
  "Dark Grey Heather/Black": { "hex": "#5f6162" },
  "Dark Heather": { "hex": "#425563" },
  "Dark Lavender": { "hex": "#734f96" },
  "Dark Navy": { "hex": "#00263a" },
  "Deep Heather": { "hex": "#696969" },
  "Deep Heather Speckled": { "hex": "#636363" },
  "Deep Purple": { "hex": "#4d227b" },
  "Deep Royal": { "hex": "#1a44b4" },
  "Denim Heather": { "hex": "#94a6b7" },
  "Dust": { "hex": "#bcae9e" },
  "Dusty Blue": { "hex": "#88a5b2" },
  "Dusty Rose": { "hex": "#e1bbb4" },
  "Espresso": { "hex": "#5C4033" },
  "Fern": { "hex": "#71bc78" },
  "Fiji Blue": { "hex": "#7d97a6" },
  "Flo Blue": { "hex": "#6981c0" },
  "Forest Green": { "hex": "#273b33" },
  "French Vanilla": { "hex": "#f7e5b3" },
  "Frost Grey Heather": { "hex": "#d3d3d6" },
  "Garnet": { "hex": "#7d2935" },
  "Gold": { "hex": "#eead1a" },
  "Golden Pecan": { "hex": "#bc987e" },
  "Green Triblend": { "hex": "#4e6155" },
  "Grey Triblend": { "hex": "#8e8e8e" },
  "Gunmetal": { "hex": "#939694" },
  "Heather Blue Lagoon": { "hex": "#6fa8bc" },
  "Heather Columbia Blue": { "hex": "#a3c9e2" },
  "Heather Deep Teal": { "hex": "#2a6266" },
  "Heather Dusty Blue": { "hex": "#a4b9ce" },
  "Heather Forest": { "hex": "#5a7164" },
  "Heather French Vanilla": { "hex": "#f4e7c7" },
  "Heather Irish Green": { "hex": "#5caa7f" },
  "Heather Maroon": { "hex": "#7e3a40" },
  "Heather Mustard": { "hex": "#eac75a" },
  "Heather Olive": { "hex": "#8B8C59" },
  "Heather Orchid": { "hex": "#b4a1b4" },
  "Heather Purple": { "hex": "#614b79" },
  "Heather Red/Deep Heather": { "hex": "#b2515b" },
  "Heather Sand Dune": { "hex": "#d1c2b0" },
  "Heather Slate": { "hex": "#708090" },
  "Heather Stone": { "hex": "#cfc6b8" },
  "Heather Sunset": { "hex": "#f2a591" },
  "Heather True Royal/Navy": { "hex": "#3d5a7d" },
  "Heliconia": { "hex": "#db3e79" },
  "Hibiscus": { "hex": "#e26a79" },
  "Hunter Green": { "hex": "#355E3B" },
  "Hydrangea": { "hex": "#B4D0EC" },
  "Ice Blue Triblend": { "hex": "#a2bacb" },
  "Independence Red": { "hex": "#932737" },
  "Irish Green": { "hex": "#00a74a" },
  "Ivory": { "hex": "#F3E8D1" },
  "Kelly Triblend": { "hex": "#008351" },
  "Lagoon Blue": { "hex": "#0077be" },
  "Lake": { "hex": "#546181" },
  "Lavender Blue": { "hex": "#c2c5e8" },
  "Leaf": { "hex": "#788753" },
  "Light Green": { "hex": "#5d8a75" },
  "Light Pink": { "hex": "#e4c6d4" },
  "Lilac": { "hex": "#b48fbf" },
  "Maroon Mist": { "hex": "#6d273c" },
  "Maroon Triblend": { "hex": "#800000" },
  "Mauve Triblend": { "hex": "#ab8a9a" },
  "Military Green Heather": { "hex": "#828770" },
  "Mint": { "hex": "#3eb489" },
  "Mint Green": { "hex": "#a0cfa8" },
  "Mint To Be": { "hex": "#b3d2c6" },
  "Mist": { "hex": "#E5E5E5" },
  "Mustard Triblend": { "hex": "#e5b550" },
  "Navy Mist": { "hex": "#2c4068" },
  "Navy Speckled": { "hex": "#2e3b4e" },
  "Navy Triblend": { "hex": "#3c4d69" },
  "Neon Cantaloupe": { "hex": "#FFA07A" },
  "Neon Green": { "hex": "#39ff14" },
  "Neon Lemon": { "hex": "#EFFF00" },
  "Neon Violet": { "hex": "#B026FF" },
  "Neon Yellow": { "hex": "#ffff33" },
  "Oatmeal Triblend": { "hex": "#e3dacb" },
  "Ocean": { "hex": "#0077be" },
  "Off White": { "hex": "#faf9f6" },
  "Olive": { "hex": "#808000" },
  "Olive Triblend": { "hex": "#6f6c4f" },
  "Orange": { "hex": "#f4633a" },
  "Orange Triblend": { "hex": "#f47f39" },
  "Orchid": { "hex": "#DA70D6" },
  "Oxford": { "hex": "#808080" },
  "Pale Yellow Triblend": { "hex": "#fef7d1" },
  "Peach Triblend": { "hex": "#f7b095" },
  "Peachy": { "hex": "#FFCBA4" },
  "Pebble Brown": { "hex": "#A49382" },
  "Pepper": { "hex": "#4D4C4A" },
  "Pink Lemonade": { "hex": "#f9d8d9" },
  "Pink Lemonade Mist": { "hex": "#ff8aad" },
  "Pistachio": { "hex": "#a9c47f" },
  "Pitch Black Mist": { "hex": "#2d2d2d" },
  "Plumrose": { "hex": "#c9809e" },
  "Purple": { "hex": "#464e7e" },
  "Purple Iris": { "hex": "#a490ba" },
  "Purple Storm": { "hex": "#6f5b7b" },
  "Purple Triblend": { "hex": "#6c4d7e" },
  "Putty": { "hex": "#d3c8b4" },
  "Raspberry": { "hex": "#e30b5d" },
  "Red Mist": { "hex": "#fb485b" },
  "Red Speckled": { "hex": "#c43c3c" },
  "Red Triblend": { "hex": "#b52b31" },
  "Rock": { "hex": "#8a8a8a" },
  "Royal Mist": { "hex": "#456db0" },
  "Sage": { "hex": "#819e87" },
  "Safety Green": { "hex": "#c6d219" },
  "Safety Orange": { "hex": "#e5801c" },
  "Safety Pink": { "hex": "#ff99cc" },
  "Sand": { "hex": "#c2b280" },
  "Sapphire": { "hex": "#0984b8" },
  "Scarlet Red": { "hex": "#ff2400" },
  "Scuba Blue": { "hex": "#00bfff" },
  "Seafoam": { "hex": "#9FE2BF" },
  "Seaglass": { "hex": "#a4c2a3" },
  "Slate Heather": { "hex": "#778899" },
  "Smoke": { "hex": "#3d3935" },
  "Soft Pink": { "hex": "#F6D1D1" },
  "Solid Baby Blue Blend": { "hex": "#89cff0" },
  "Solid Dark Grey Triblend": { "hex": "#696969" },
  "Solid Kelly Blend": { "hex": "#4cbb17" },
  "Solid Natural Blend": { "hex": "#f5f5dc" },
  "Solid Natural Triblend": { "hex": "#e7e2d4" },
  "Solid Navy Blend": { "hex": "#000080" },
  "Solid Navy Triblend": { "hex": "#3c4d69" },
  "Solid Pink Blend": { "hex": "#ffc0cb" },
  "Solid Red Blend": { "hex": "#ff0000" },
  "Solid White Blend": { "hex": "#F0F0F0" },
  "Steel Blue": { "hex": "#294f5a" },
  "Stone Blue": { "hex": "#92a1a9" },
  "Storm Grey": { "hex": "#898d8d" },
  "Sweet Cream Heather": { "hex": "#f2edd9" },
  "Synthetic Green": { "hex": "#6ECB63" },
  "Tan": { "hex": "#bd9a7a" },
  "Teal Ice": { "hex": "#b1e4e3" },
  "Teal Triblend": { "hex": "#008080" },
  "Team Purple": { "hex": "#800080" },
  "Terracotta": { "hex": "#fea38e" },
  "Toast": { "hex": "#D2B48C" },
  "True Navy": { "hex": "#29354f" },
  "True Royal Triblend": { "hex": "#002366" },
  "Turquoise": { "hex": "#40E0D0" },
  "Umber": { "hex": "#635147" },
  "Vintage Black": { "hex": "#1C1C1C" },
  "Vintage Brown": { "hex": "#8a7967" },
  "Vintage Heather Blue": { "hex": "#5a7e9e" },
  "Vintage Heather Navy": { "hex": "#4f5a69" },
  "Vintage Heather Red": { "hex": "#d86060" },
  "Vintage Navy": { "hex": "#4f5a69" },
  "Vintage Red": { "hex": "#b22222" },
  "Vintage White": { "hex": "#F9F9F1" },
  "Violet": { "hex": "#8094dd" },
  "Washed Denim": { "hex": "#6F8FAF" },
  "Washed Navy": { "hex": "#5e6a71" },
  "White Fleck Triblend": { "hex": "#e9e9e9" },
  "White Slub": { "hex": "#fafafa" },
  "White/Athletic Heather": { "hex": "#dcdcdc" },
  "White/Baby Blue": { "hex": "#c1e1f0" },
  "White/Denim": { "hex": "#d2d9e0" },
  "White/Heather Peach": { "hex": "#fde4d3" },
  "White/Kelly": { "hex": "#cde7c1" },
  "White/Pink": { "hex": "#ffe2e6" },
  "Wine": { "hex": "#722F37" },
  "Yam": { "hex": "#CC6B3D" },
  "Yellow": { "hex": "#f5e050" },
  "Yellow Gold Triblend": { "hex": "#e7c75a" },
  "Neon Pink": { hex: "#FF6EC7" },     
    "Neon Blue": { hex: "#0c51a3" },  
      "Terracotta": { hex: "#fea38e" },  
  "Pebble Brown": { hex: "#A49382" },
    "Independence Red": { hex: "#932737" },
      "Lake": { hex: "#546181" },
        "Blue Spruce": { hex: "#536964" },
          "Denim": { hex: "#535a68" },
        "Flo Blue": { hex: "#6981c0" },
        "Light Green": { hex: "#5d8a75" },
          "True Navy": { hex: "#29354f" },
    "Dark Grey":        { hex: "#4B4B4B" },     // Koyu gri, duman tonu
  "Soft Pink":        { hex: "#F6D1D1" },     // Pudra pembe, yumuşak ton
  "Toast":            { hex: "#D2B48C" },     // Açık kahve, tost/bej arası
  "Vintage Black":    { hex: "#1C1C1C" },     // Hafif solgun siyah, yıkanmış efekt
  "Vintage White":    { hex: "#F9F9F1" },      // Kirli beyaz / nostaljik açık krem
  "Blue Jean":     { hex: "#5B6E7D" },
"Butter":        { hex: "#F6E27F" },
  "Dusty Rose":        { hex: "#e1bbb4" },

  "Gunmetal":        { hex: "#939694" },
"Maroon Mist":       { hex: "#6d273c" },
"Navy Mist":          { hex: "#2c4068" },
"Pitch Black": { hex: "#101820" },
"Plumrose":         { hex: "#c9809e" },
"Red Mist":   { hex: "#fb485b" },
"Slate":        { hex: "#b3aaa4" },
"Steel Blue":        { hex: "#294f5a" },
    "Cactus":        { hex: "#788a7a" },
"Caribbean Mist":       { hex: "#00a9ce" },
"Cement":          { hex: "#aeaeae" },
"Daisy Mist": { hex: "#fed101" },
  "Daisy": { hex: "#fed101" },
    "Sage": { hex: "#819e87" },
      "Dark Navy": { hex: "#00263a" },
"Pink Lemonade Mist":         { hex: "#ff8aad" },
"Pitch Black Mist":   { hex: "#2d2d2d" },
"Royal Mist":        { hex: "#456db0" },

    "Blue Dusk":        { hex: "#253746" },
"Cherry Red":       { hex: "#ac2b37" },
"Dark Chocolate":          { hex: "#382f2d" },
"Deep Royal": { hex: "#1a44b4" },
"Garnet":         { hex: "#7d2935" },
"Tan":        { hex: "#bd9a7a" },
  "Charcoal":   { hex: "#1e1e1e" },
"Orange":        { hex: "#f4633a" },
  "Safety Orange":        { hex: "#e5801c" },
"Carolina Blue":         { hex: "#7ba4db" },
"Forest Green":   { hex: "#273b33" },
"Gold":        { hex: "#eead1a" },
  "Brick":        { hex: "#7f3338" },
    "Dark Heather":        { hex: "#425563" },

  "Baby Blue":        { hex: "#69b3e7" },
"Caribbean Blue":       { hex: "#00a9ce" },
"Charity Pink":          { hex: "#f8a3bc" },
"Heather Blue": { hex: "#3a5dae" },
"Heather Dark Grey":         { hex: "#4e4f4a" },
"Heather Navy":        { hex: "#333f48" },
"Royal Blue":        { hex: "#1968c7" },
    "Smoke":        { hex: "#3d3935" },
"Storm Grey":       { hex: "#898d8d" },
"Teal Ice":          { hex: "#b1e4e3" },
"True Red": { hex: "#bb1237" },
  "Azalea": { hex: "#dd74a1" },
    "Coral Silk": { hex: "#fb637e" },
"Heliconia":       { hex: "#db3e79" },
    "Heather Irish Green": { hex: "#5caa7f" },
    "Heather Purple": { hex: "#614b79" },
"Light Blue":          { hex: "#a4c8e1" },
"Light Pink": { hex: "#e4c6d4" },
"Mint Green":         { hex: "#a0cfa8" },
"Pistachio":   { hex: "#a9c47f" },
"Purple":        { hex: "#464e7e" },
"Royal":        { hex: "#224d8f" },
  "Safety Green":   { hex: "#c6d219" },
"Sapphire":        { hex: "#0984b8" },
  "Irish Green":        { hex: "#00a74a" },
    "Violet":        { hex: "#8094dd" },
"Crimson":       { hex: "#8C1C13" },
"Grey":          { hex: "#9A9A9A" },
"Hydrangea": { hex: "#B4D0EC" },
"Ivory":         { hex: "#F3E8D1" },
"Neon Violet":   { hex: "#B026FF" },
"Peachy":        { hex: "#FFCBA4" },
"Pepper":        { hex: "#4D4C4A" },
"Chalky Mint":   { hex: "#A8E6CF" },
"Espresso":      { hex: "#5C4033" },
"Yam":           { hex: "#CC6B3D" },
"Seafoam":       { hex: "#9FE2BF" },
"Wine":          { hex: "#722F37" },
"Washed Denim":  { hex: "#6F8FAF" },
  "Heather Columbia Blue": { hex: "#a3c9e2" },
  "Heather Dust": { hex: "#e8dfd6" },
  "Heather Maroon": { hex: "#7e3a40" },
  "Heather Mauve": { hex: "#c9a9a6" },
  "Heather Stone": { hex: "#cfc6b8" },
  "Natural": { hex: "#f5f1e8" },
  "Navy": { hex: "#1a1d49" },
  "Pink": { hex: "#f9c3d0" },
  "Red": { hex: "#d02d2d" },
  "Storm": { hex: "#a1a1a1" },
  "True Royal": { hex: "#2b53a4" },
  "Black": { hex: "#000000" },
  "Heather Deep Teal": { hex: "#2a6266" },
  "Heather Dusty Blue": { hex: "#a4b9ce" },
  "Heather Mustard": { hex: "#eac75a" },
  "Heather Peach": { hex: "#f4c8b7" },
  "Heather Sunset": { hex: "#f2a591" },
  "Lavender Blue": { hex: "#c2c5e8" },
  "Lilac": { hex: "#b48fbf" },
  "Maroon": { hex: "#800000" },
  "Mauve": { hex: "#c9a9a6" },
  "Military Green": { hex: "#4b5320" },
  "Navy": { hex: "#1a1d49" },
  "Red": { hex: "#d02d2d" },
  "White": { hex: "#ffffff" },
  "Berry": { hex: "#A63A79" },
"Black Heather": { hex: "#2E2E2E" },
"Heather Olive": { hex: "#8B8C59" },
"Heather Slate": { hex: "#708090" },
"Heather True Royal": { hex: "#2B3856" },
"Kelly": { hex: "#4CBB17" },
"Mist": { hex: "#E5E5E5" },
"Mustard": { hex: "#FFDB58" },
"Slate Heather": { hex: "#778899" },
"Solid Black Blend": { hex: "#2B2B2B" },
"Solid White Blend": { hex: "#F0F0F0" },
"Sunset": { hex: "#FFCC99" },
"Synthetic Green": { hex: "#6ECB63" },
"Team Purple": { hex: "#800080" },
"Teal": { hex: "#008080" },
"Turquoise": { hex: "#40E0D0" },
  "Cardinal Red": { hex: "#9D2235" },
"Neon Cantaloupe": { hex: "#FFA07A" },
"Neon Lemon": { hex: "#EFFF00" },
"Orchid": { hex: "#DA70D6" },
"Chambray": { hex: "#3C6382" },
  "Yellow": { hex: "#f5e050" }
};

class VariantSelector {
  constructor() {
    this.variantSwatches = VARIANT_SWATCHES;
    this.selectedOptions = {
      color: null,
      quantities: {}
    };
    
    this.init();
    console.log('VariantSelector initialized');
  }

  init() {
    console.log('VariantSelector init called');
    this.container = document.querySelector('.product-variant-selector');
    if (!this.container) {
      console.log('No product-variant-selector container found');
      return;
    }
    console.log('Found product-variant-selector container');

    this.productForm = document.querySelector('product-form');
    this.variantRadios = document.querySelector('variant-radios');
    this.variantSelects = document.querySelector('variant-selects');

    this.setupColorSwatches();
    this.setupQuantityControls();
    this.setupAddToCartButton();
    this.bindEvents();
  }

  setupColorSwatches() {
  const colorVariants = this.getUniqueColorOptions();
  const swatchContainer = this.container.querySelector('.swatch-container');
  const variantLabel = this.container.querySelector('.variant-label');

  if (!swatchContainer || !variantLabel) return;

  // Variant label'ı container içine al
  const labelContainer = document.createElement('div');
  labelContainer.className = 'variant-label-container';
  variantLabel.parentNode.insertBefore(labelContainer, variantLabel);
  labelContainer.appendChild(variantLabel);

  // Selected color span'i ekle
  const selectedColorSpan = document.createElement('span');
  selectedColorSpan.className = 'selected-color';
  labelContainer.appendChild(selectedColorSpan);

  // Label metni
  variantLabel.textContent = 'Selected Color:';

  swatchContainer.innerHTML = '';

  colorVariants.forEach(color => {
    const swatch = document.createElement('div');
    swatch.className = 'swatch-element';
    swatch.setAttribute('data-color', color);

    // Tooltip
    const tooltip = document.createElement('span');
    tooltip.className = 'swatch-tooltip';
    tooltip.textContent = this.formatColorName(color);
    swatch.appendChild(tooltip);

    const swatchData = this.variantSwatches?.[color] || {};

    if (swatchData.img) {
      const img = document.createElement('img');
      img.src = swatchData.img;
      img.alt = this.formatColorName(color);
      swatch.appendChild(img);
    } else if (swatchData.hex) {
      swatch.style.backgroundColor = swatchData.hex;
    } else {
      // fallback renk
      swatch.style.backgroundColor = '#ccc';
    }

    swatchContainer.appendChild(swatch);
  });

  // İlk swatch'u otomatik seç
  const firstSwatch = swatchContainer.querySelector('.swatch-element');
  if (firstSwatch) {
    this.handleColorSelection(firstSwatch);
  }
}

  updateSizeOptions(selectedColor) {
    const sizeGrid = this.container.querySelector('.size-grid');
    if (!sizeGrid) return;

    const colorVariants = window.productVariants.filter(v => v.option1 === selectedColor);
    
    sizeGrid.innerHTML = '';
    
    colorVariants.forEach(variant => {
      const variantData = document.querySelector(`[data-variant-inventory="${variant.id}"]`);
      const inventory = variantData ? parseInt(variantData.textContent) : 0;
      const isAvailable = inventory > 0;
      
      const sizeBox = document.createElement('div');
      sizeBox.className = `size-box${!isAvailable ? ' out-of-stock' : ''}`;
      sizeBox.setAttribute('data-value', variant.option2);
      sizeBox.setAttribute('data-variant-id', variant.id);
      
      let stockText = isAvailable ? `${inventory}` : 'OUT';
      let stockCount = isAvailable ? inventory : 0;
      
      sizeBox.innerHTML = `
        <div class="size-name">${variant.option2}</div>
        <div class="variant-price">${this.formatMoney(variant.price)}</div>
        <div class="variant-stock">
          ${isAvailable ? 
            `<div class="quantity-controls">
              <button type="button" class="quantity-btn quantity-btn--minus">-</button>
              <input type="number" 
                     class="quantity-input" 
                     value="0" 
                     min="0" 
                     max="${stockCount}"
                     data-variant-id="${variant.id}">
              <button type="button" class="quantity-btn quantity-btn--plus">+</button>
            </div>
            <span class="stock-count">${stockText}</span>` : 
            'OUT'}
        </div>
      `;
      
      sizeGrid.appendChild(sizeBox);
    });
    
    this.setupQuantityControls();
    this.updateTotalQuantity();
  }

  setupQuantityControls() {
    this.container.querySelectorAll('.quantity-controls').forEach(control => {
      // Önceki event listener'ları temizle
      const minusBtn = control.querySelector('.quantity-btn--minus');
      const plusBtn = control.querySelector('.quantity-btn--plus');
      const input = control.querySelector('.quantity-input');
      
      // Eski event listener'ları kaldır
      minusBtn.replaceWith(minusBtn.cloneNode(true));
      plusBtn.replaceWith(plusBtn.cloneNode(true));
      input.replaceWith(input.cloneNode(true));
      
      // Yeni elementleri seç
      const newMinusBtn = control.querySelector('.quantity-btn--minus');
      const newPlusBtn = control.querySelector('.quantity-btn--plus');
      const newInput = control.querySelector('.quantity-input');
      
      const variantId = newInput.dataset.variantId;
      const maxQuantity = parseInt(newInput.getAttribute('max')) || 9999;

      this.selectedOptions.quantities[variantId] = 0;

      // Yeni event listener'ları ekle
      newMinusBtn.addEventListener('click', (e) => {
        e.preventDefault(); // Form submit'i engelle
        const currentValue = parseInt(newInput.value) || 0;
        if (currentValue > 0) {
          newInput.value = currentValue - 1;
          this.selectedOptions.quantities[variantId] = currentValue - 1;
          this.updateTotalQuantity();
        }
      });

      newPlusBtn.addEventListener('click', (e) => {
        e.preventDefault(); // Form submit'i engelle
        const currentValue = parseInt(newInput.value) || 0;
        if (currentValue < maxQuantity) {
          newInput.value = currentValue + 1;
          this.selectedOptions.quantities[variantId] = currentValue + 1;
          this.updateTotalQuantity();
        }
      });

      newInput.addEventListener('change', () => {
        let value = parseInt(newInput.value) || 0;
        if (value < 0) value = 0;
        if (value > maxQuantity) value = maxQuantity;
        newInput.value = value;
        this.selectedOptions.quantities[variantId] = value;
        this.updateTotalQuantity();
      });
    });
}

  updateTotalQuantity() {
    const totalQuantity = Object.values(this.selectedOptions.quantities)
      .reduce((sum, qty) => sum + qty, 0);
    
    const addToCartBtn = this.container.querySelector('.product-form__submit');
    if (addToCartBtn) {
      const minQtyAttr = parseInt(this.container.getAttribute('data-min-qty')) || 0;
      const minQty = Number.isFinite(minQtyAttr) ? minQtyAttr : 0;
      const hasMinRequirement = minQty > 0;

      const warningEl = this.container.querySelector('.min-qty-warning');
      const meetsMin = hasMinRequirement ? totalQuantity >= minQty : totalQuantity > 0;

      // Disable/enable button according to min requirement
      addToCartBtn.disabled = !meetsMin;

      // Update label
      if (totalQuantity === 0) {
        addToCartBtn.textContent = 'Select Options';
      } else if (hasMinRequirement && totalQuantity < minQty) {
        addToCartBtn.textContent = `Add ${minQty - totalQuantity} more`;
      } else {
        addToCartBtn.textContent = 'Add to Cart';
      }

      // Toggle warning visibility
      if (warningEl) {
        warningEl.style.display = hasMinRequirement && totalQuantity > 0 && totalQuantity < minQty ? 'block' : 'none';
      }
    }
    
    // Update order summary
    this.updateOrderSummary();
  }
  
  updateOrderSummary() {
    const summaryContainer = this.container.querySelector('.order-summary-container');
    if (!summaryContainer) return;
    
    const bundleType = this.container.getAttribute('data-bundle-type');
    const bundleConfig = window.bundleConfig || {};
    const minQty = bundleConfig.minQty || (bundleType === '50' ? 50 : bundleType === '100' ? 100 : 0);
    const unitPrice = bundleConfig.unitPrice || (bundleType === '50' ? 4.98 : bundleType === '100' ? 4.49 : 0);
    
    const totalQuantity = Object.values(this.selectedOptions.quantities)
      .reduce((sum, qty) => sum + qty, 0);
    
    if (totalQuantity === 0) {
      summaryContainer.style.display = 'none';
      return;
    }
    
    summaryContainer.style.display = 'block';
    const summaryBody = summaryContainer.querySelector('#size-summary-body');
    if (!summaryBody) return;
    
    summaryBody.innerHTML = '';
    let grandTotal = 0;
    
    // Get YMQ options price
    const ymqPrice = this.getYmqTotalPrice();
    
    Object.entries(this.selectedOptions.quantities).forEach(([variantId, qty]) => {
      if (qty === 0) return;
      
      const variant = window.productVariants.find(v => v.id === parseInt(variantId));
      if (!variant) return;
      
      const size = variant.option2 || variant.title.split(' / ')[1] || '';
      const effectiveUnitPrice = totalQuantity >= minQty ? unitPrice : (variant.price / 100);
      const subtotal = effectiveUnitPrice * qty;
      grandTotal += subtotal;
      
      const row = document.createElement('tr');
      row.innerHTML = `
        <td>${size}</td>
        <td>${qty}</td>
        <td>${this.formatMoney(effectiveUnitPrice * 100)}</td>
        <td>${this.formatMoney(subtotal * 100)}</td>
      `;
      summaryBody.appendChild(row);
    });
    
    // Add YMQ price to total if exists
    grandTotal += ymqPrice;
    
    const totalElement = summaryContainer.querySelector('#order-summary-total');
    if (totalElement) {
      totalElement.textContent = this.formatMoney(grandTotal * 100);
    }
    
    // Show disclaimer if bundle pricing applies
    const disclaimer = summaryContainer.querySelector('#order-summary-disclaimer');
    if (disclaimer && totalQuantity >= minQty) {
      disclaimer.style.display = 'block';
    } else if (disclaimer) {
      disclaimer.style.display = 'none';
    }
  }
  
  getYmqTotalPrice() {
    let total = 0;
    const ymqPriceInput = document.getElementById('ymq-hidden-inputs')?.querySelector('.ymq-option-hidden-input[name="properties[_YmqItemPrice]"]');
    if (ymqPriceInput) {
      total = parseFloat(ymqPriceInput.value) || 0;
    }
    return total;
  }

  setupAddToCartButton() {
    console.log('setupAddToCartButton called');
    const addToCartBtn = this.container.querySelector('.product-form__submit');
    if (addToCartBtn) {
      console.log('Found add to cart button, adding event listener');
      addToCartBtn.addEventListener('click', () => this.addToCart());
    } else {
      console.log('No add to cart button found');
    }
  }

  bindEvents() {
    this.container.addEventListener('click', (e) => {
      const swatch = e.target.closest('.swatch-element');
      if (swatch) {
        this.handleColorSelection(swatch);
      }
    });
    
    // Listen for YMQ option changes - multiple event types
    const ymqContainer = document.querySelector('ymq-option');
    if (ymqContainer) {
      // Listen for input changes
      ymqContainer.addEventListener('change', (e) => {
        this.updateYmqHiddenInputs();
        this.updateTotalQuantity();
      });
      
      // Listen for clicks (for radio/checkbox)
      ymqContainer.addEventListener('click', (e) => {
        if (e.target.type === 'radio' || e.target.type === 'checkbox') {
          setTimeout(() => {
            this.updateYmqHiddenInputs();
            this.updateTotalQuantity();
          }, 100);
        }
      });
    }
    
    // Also listen globally for YMQ changes
    document.addEventListener('change', (e) => {
      if (e.target.closest('ymq-option') || e.target.closest('.ymq-option')) {
        this.updateYmqHiddenInputs();
        this.updateTotalQuantity();
      }
    });
    
    // Use MutationObserver to watch for YMQ changes
    const observer = new MutationObserver(() => {
      this.updateYmqHiddenInputs();
      this.updateTotalQuantity();
    });
    
    const ymqOption = document.querySelector('ymq-option');
    if (ymqOption) {
      observer.observe(ymqOption, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'selected', 'checked']
      });
    }
    
    // Initial YMQ inputs update
    setTimeout(() => {
      this.updateYmqHiddenInputs();
      this.updateTotalQuantity();
    }, 1000);
  }
  
  updateYmqHiddenInputs() {
    const container = document.getElementById('ymq-hidden-inputs');
    if (!container) return;
    
    container.innerHTML = '';
    
    // Find all YMQ option inputs
    const ymqOptions = document.querySelectorAll('ymq-option');
    let totalYmqPrice = 0;
    
    ymqOptions.forEach(ymqOption => {
      // Get radio inputs
      const radioInputs = ymqOption.querySelectorAll('input[type="radio"]:checked');
      radioInputs.forEach(input => {
        const name = input.getAttribute('name');
        const value = input.value;
        
        if (!name || !value) return;
        
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.className = 'ymq-option-hidden-input';
        hiddenInput.name = `properties[${name.split('-')[0]}]`;
        hiddenInput.value = value;
        container.appendChild(hiddenInput);
        
        // Check for price
        const price = parseFloat(input.getAttribute('ymq-option-price')) || 0;
        if (price > 0) {
          totalYmqPrice += price;
        }
      });
      
      // Get select inputs
      const selectInputs = ymqOption.querySelectorAll('select');
      selectInputs.forEach(select => {
        const name = select.getAttribute('name');
        const value = select.value;
        
        if (!name || !value) return;
        
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.className = 'ymq-option-hidden-input';
        hiddenInput.name = `properties[${name.split('-')[0]}]`;
        hiddenInput.value = value;
        container.appendChild(hiddenInput);
        
        // Check for price in selected option
        const selectedOption = select.options[select.selectedIndex];
        const price = parseFloat(selectedOption.getAttribute('ymq-option-price')) || 0;
        if (price > 0) {
          totalYmqPrice += price;
        }
      });
      
      // Get textarea inputs
      const textareaInputs = ymqOption.querySelectorAll('textarea');
      textareaInputs.forEach(textarea => {
        const name = textarea.getAttribute('name');
        const value = textarea.value;
        
        if (!name || !value) return;
        
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.className = 'ymq-option-hidden-input';
        hiddenInput.name = `properties[${name.split('-')[0]}]`;
        hiddenInput.value = value;
        container.appendChild(hiddenInput);
      });
    });
    
    // Add total YMQ price if exists
    if (totalYmqPrice > 0) {
      const priceInput = document.createElement('input');
      priceInput.type = 'hidden';
      priceInput.className = 'ymq-option-hidden-input';
      priceInput.name = 'properties[_YmqItemPrice]';
      priceInput.value = totalYmqPrice.toString();
      container.appendChild(priceInput);
    }
  }

handleColorSelection(swatch) {
  const color = swatch.getAttribute('data-color');
  this.selectedOptions.color = color;

  // Selected color text'ini güncelle
  const selectedColorSpan = this.container.querySelector('.selected-color');
  if (selectedColorSpan) {
    selectedColorSpan.textContent = this.formatColorName(color);
  }

  // Swatch seçimini güncelle
  this.container.querySelectorAll('.swatch-element').forEach(el => {
    el.classList.remove('selected');
  });
  swatch.classList.add('selected');

  // Seçilen variant'ı bul
  const selectedVariant = window.productVariants.find(v => v.option1 === color);
  if (!selectedVariant) return;

  // ✅ Product form içindeki variant id’yi güncelle
  this.triggerVariantChange();

  // ✅ Motion Theme'de ilgili thumbnail'a tıkla
  const matchingThumb = document.querySelector(`a[data-id="${selectedVariant.featured_media?.id}"]`);
  if (matchingThumb) {
    matchingThumb.click();
  }

  // ✅ Boyut seçeneklerini güncelle
  this.updateSizeOptions(color);
}




  formatColorName(color) {
    return color.replace(/\s*-\s*\d+$/, '').trim();
  }

  triggerVariantChange() {
    if (!this.selectedOptions.color) return;

    const variant = window.productVariants.find(v => v.option1 === this.selectedOptions.color);
    if (!variant) return;

    if (this.variantRadios) {
      const input = this.variantRadios.querySelector(`input[value="${variant.id}"]`);
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (this.variantSelects) {
      const select = this.variantSelects.querySelector('select');
      if (select) {
        select.value = variant.id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (this.productForm) {
      const input = this.productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  addToCart() {
    console.log('addToCart called');
    // Guard: enforce minimum quantity if defined on container
    const minQtyAttr = parseInt(this.container.getAttribute('data-min-qty')) || 0;
    const minQty = Number.isFinite(minQtyAttr) ? minQtyAttr : 0;
    if (minQty > 0) {
      const totalQuantity = Object.values(this.selectedOptions.quantities)
        .reduce((sum, qty) => sum + qty, 0);
      if (totalQuantity < minQty) {
        const warningEl = this.container.querySelector('.min-qty-warning');
        if (warningEl) {
          warningEl.style.display = 'block';
        }
        return; // prevent add
      }
    }
    
    // Collect YMQ properties
    const ymqProperties = this.collectYmqProperties();
    
    const items = [];
    Object.entries(this.selectedOptions.quantities).forEach(([variantId, quantity]) => {
      if (quantity > 0) {
        items.push({
          id: parseInt(variantId),
          quantity: quantity,
          properties: ymqProperties
        });
      }
    });

    if (items.length === 0) {
      alert('Please select at least one size and quantity');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(() => {
      console.log('Product added to cart successfully');
      // Use global cart functions if available
      if (typeof window.openCartDrawer === 'function') {
        console.log('Using window.openCartDrawer');
        window.openCartDrawer();
      } else if (typeof window.refreshCart === 'function') {
        console.log('Using window.refreshCart');
        window.refreshCart();
      } else {
        console.log('Using cart:refresh event');
        // Fallback: dispatch cart refresh event
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      // Cart updated event'ini dispatch et
      document.dispatchEvent(new CustomEvent('cart:updated'));

      this.container.querySelectorAll('.quantity-input').forEach(input => {
        input.value = 0;
      });
      this.selectedOptions.quantities = {};
      this.updateTotalQuantity();
    })
    .catch((error) => {
      console.error('[VariantSelector] Cart add error:', error);
      // Kullanıcıya bildir (opsiyonel)
      alert('Failed to add product to cart. Please try again.');
    });
  }
  
  collectYmqProperties() {
    const properties = {};
    const ymqInputs = document.querySelectorAll('.ymq-option-hidden-input');
    ymqInputs.forEach(input => {
      const name = input.getAttribute('name');
      const value = input.value;
      if (name && value) {
        // Remove 'properties[' and ']' from name
        const propName = name.replace(/^properties\[/, '').replace(/\]$/, '');
        properties[propName] = value;
      }
    });
    return properties;
  }

  getUniqueColorOptions() {
    return [...new Set(window.productVariants.map(variant => variant.option1))];
  }

  formatMoney(cents) {
    return window.theme?.moneyFormat?.replace('{{amount}}', (cents/100).toFixed(2)) || `$${(cents/100).toFixed(2)}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded - initializing VariantSelector');
  console.log('Current template:', document.body.className);
  console.log('Product variants:', window.productVariants);
  new VariantSelector();
  
  // CloudLift form submit interceptor for minimum quantity validation
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    // Check if this is a CloudLift form with minimum quantity requirement
    const minQtyInput = form.querySelector('input[name="properties[_cl_options_quantity_min]"]');
    if (!minQtyInput) return;
    
    const minQty = parseInt(minQtyInput.value) || 0;
    if (minQty <= 0) return;
    
    // Get quantity input
    const quantityInput = form.querySelector('input[name="quantity"]');
    if (!quantityInput) return;
    
    const selectedQuantity = parseInt(quantityInput.value) || 0;
    
    // Check minimum quantity
    if (selectedQuantity < minQty) {
      e.preventDefault();
      
      // Show error message
      let errorDiv = form.querySelector('.min-qty-error');
      if (!errorDiv) {
        errorDiv = document.createElement('div');
        errorDiv.className = 'min-qty-error';
        errorDiv.style.cssText = 'color: #b00020; margin: 8px 0 12px; padding: 8px; background: #ffebee; border: 1px solid #b00020; border-radius: 4px;';
        form.insertBefore(errorDiv, form.querySelector('.payment-buttons'));
      }
      
      errorDiv.textContent = `Minimum order quantity for Genuine Leather Patches is ${minQty}.`;
      errorDiv.style.display = 'block';
      
      // Scroll to error
      errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      return false;
    }
    
    // Hide error if quantity is valid
    const errorDiv = form.querySelector('.min-qty-error');
    if (errorDiv) {
      errorDiv.style.display = 'none';
    }
  });
});

if (typeof window !== 'undefined') {
  window.VARIANT_SWATCHES = VARIANT_SWATCHES;
}
